import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyThunkApiConfig } from '../../types';

export const getJobListWithCrewAction = createAsyncThunk<
  any,
  { graphqlFunction: (params: any) => Promise<any>; params: any },
  MyThunkApiConfig
>('job/jobListWithCrew', async (inputData, { rejectWithValue }) => {
  const { graphqlFunction, params } = inputData;
  try {
    const response = await graphqlFunction(params);
    return response?.getJobsByCrew;
  } catch (error) {
    return rejectWithValue({ error: error.message });
  }
});
